import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import es from './es.json';

const STORAGE_KEY = 'trini_wallet_language';

// Registered before init so the initial language is applied to <html lang>
// too, not only later switches.
i18n.on('languageChanged', (language) => {
  const normalized = language.startsWith('en') ? 'en' : 'es';
  localStorage.setItem(STORAGE_KEY, normalized);
  document.documentElement.lang = normalized;
});

void i18n
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, es: { translation: es } },
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    // Spanish unless the person chose otherwise; the browser locale does not decide.
    lng: localStorage.getItem(STORAGE_KEY) ?? 'es',
  });

export default i18n;
